/**
 * 内置头像。**用内联 SVG 画，不发网络请求** ——
 * 十二个头像十二个请求，而且它们永远不变，没有任何理由走网络。
 */
const HUES = [0, 30, 60, 100, 140, 170, 200, 230, 260, 290, 320, 345];

export function PresetAvatar({ id, size = 56 }: { id: string; size?: number }) {
  const n = Number(id.split(':')[1] ?? 1) || 1;
  const hue = HUES[(n - 1) % HUES.length];
  // 每个编号一张不同的脸：耳朵位置、眼距、嘴形都按编号变一点
  const ear = 6 + (n % 3) * 3;
  const eye = 5 + (n % 4);
  const smile = 3 + (n % 5);
  const gid = `ag${n}`;
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} aria-hidden="true">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={`hsl(${hue} 80% 62%)`} />
          <stop offset="1" stopColor={`hsl(${(hue + 40) % 360} 75% 48%)`} />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="20" fill={`url(#${gid})`} />
      <circle cx={32 - ear} cy="20" r="4" fill="#fff" opacity=".6" />
      <circle cx={32 + ear} cy="20" r="4" fill="#fff" opacity=".6" />
      <circle cx={32 - eye} cy="30" r="2.6" fill="#1a1030" />
      <circle cx={32 + eye} cy="30" r="2.6" fill="#1a1030" />
      <path d={`M26 39 q6 ${smile} 12 0`} stroke="#1a1030" strokeWidth="2.2"
            fill="none" strokeLinecap="round" />
    </svg>
  );
}
